import Button from '@/components/Button'

interface CodeOutputProps {
  code: string
  codeRef?: React.RefObject<HTMLElement>
  onCopy: () => void
}

export function CodeOutput({ code, codeRef, onCopy }: CodeOutputProps) {
  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-semibold text-licorice dark:text-white">Generated Code</h2>
        <Button onClick={onCopy} type="button">
          Copy Code
        </Button>
      </div>
      <pre
        className="bg-gray-900 p-4 rounded-md overflow-x-auto text-sm"
        style={{ backgroundColor: '#282c34', padding: '20px' }}
      >
        <code ref={codeRef} className="language-javascript">
          {code}
        </code>
      </pre>
    </section>
  )
}
